import { NostoSectionComponent } from '@theme/nosto-section-base';

/**
 * <ax-shop-the-look-nosto> — "Shop the look" personnalisé par Nosto.
 *
 * Le contenu (hero + hotspots produits) vit dans des métaobjets Shopify
 * (`shop_the_look_nosto` → `shop_the_look_nosto_hotspot`). Nosto ne renvoie QUE le
 * handle du métaobjet (par segment). Le markup morphé embarque un
 * <ax-shop-the-look> interactif qui boote sur l'élément morphé.
 *
 * Toute la mécanique (skeleton SSR → attente du handle → re-render SFR → morph, et
 * le découplage attente-Nosto / fetch) vit dans nosto-section-base.js.
 */
class AxShopTheLookNostoComponent extends NostoSectionComponent {
  static elementName = 'ax-shop-the-look-nosto';

  get handleSelector() {
    return '[data-shop-the-look-handle], [data-handle]';
  }
}

if (!customElements.get('ax-shop-the-look-nosto')) {
  customElements.define('ax-shop-the-look-nosto', AxShopTheLookNostoComponent);
}
